// extracted by mini-css-extract-plugin
module.exports = {"fileDisplay":"styles_fileDisplay__70zwW","iconWrapper":"styles_iconWrapper__H-Ts7","fileName":"styles_fileName__3gesK","removeIcon":"styles_removeIcon__3lW2O"};